<template><div>
  <h1 class="fdd-md--h1">fd-dialog-footer</h1>
<h2 class="fdd-md--h2">Slots</h2>
<h3 class="fdd-md--h3">default</h3>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":[]},"name":"fd-dialog-footer","slots":[{"name":"default","describe":"","backerDesc":"","bindings":{},"scoped":false,"target":"template"}]}
  };
 }
}
]
  }
  </script>
  